export default "/assets/images/spring-background.jpg?79fce18de2e2d99d8c41d344490ea355";